import { CourseChapter } from '@models/courseChapter'
import { ChapterFormValues } from './types'

const getDefaultValues = (
  chapter?: CourseChapter
): Partial<ChapterFormValues> | undefined => {
  if (!chapter) return undefined

  const result: Partial<ChapterFormValues> = {
    title: chapter.title,
  }

  // Из БД hoursCount приходит числом, а поле часов маскированное и работает со
  // строкой. Приводим к строке, иначе IMask падает при монтировании (белый экран
  // при редактировании раздела уже созданного курса). Пусто не задаём, как у нового
  // раздела.
  if (chapter.hoursCount != null) {
    result.hoursCount = String(chapter.hoursCount)
  }

  return result
}

export default getDefaultValues
